import _ from 'lodash';
import async from 'async';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

//- material-ui
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import OpenLink from '@material-ui/icons/OpenInNew';

//- Container
import StationInvoiceContainer from '../../containers/accounting/StationInvoice';
import ApIngestionResultContainer from '../../containers/apAutomation/ApIngestionResult';
import InvoiceDocumentContainer from '../../containers/accounting/InvoiceDocument';
import QuickbooksContainer from '../../containers/accounting/Quickbooks';
import SuppliersContainer from '../../containers/logistics/Suppliers';
import CarriersContainer from '../../containers/logistics/Carriers';
import VendorBillContainer from '../../containers/billing/VendorBill';

// Form / UI
import FormComponent from '../../components/FormComponent';
import FMPSelect from '../../components/pureForm/FMPSelect';
import GenericSavingDialog from '../../components/Dialogs/GenericSavingDialog';
import FMPRegionHeader from '../../components/ui/FMPRegionHeader';
import Note from '../../components/ui/Note';

// Images
import GreenChecked from '../../images/icons/greenChecked.svg';
import YellowWarning from '../../images/icons/yellowWarning.svg';
import ErrorIcon from '../../images/icons/error.svg';

import {
	save,
	vendorStyles,
	getTermsFromCarrier,
	getTermsFromSupplier,
	searchForInvoiceMatch,
	renderSearchResult,
	renderMatchStatus,
	renderFreightLineItems,
	renderFuelLineItems,
	renderInvoiceDetails,
	renderInvoiceMatches,
	renderBillFields,
	renderBillTotal,
	renderMarkTransfer,
	renderOrders,
	renderSearchResultOrCurrentLinkage,
} from '../billing/vendorBillShared';
import ConfirmInvalidateApArTriage from '../../components/Dialogs/ConfirmInvalidateApArTriage';

const pBlue = '#0790CB';
const styles = (theme) => ({
	...vendorStyles(theme),
	overallMatchTitle: {
		fontSize: 26,
	},
	overallMatchSectionContainer: {
		//width: '50%',
		marginTop: 20,
		marginBottom: 15,
		fontSize: 18,
		marginRight: 20,
	},
	overallMatchSectionLabel: {
		textTransform: 'uppercase',
		color: '#777',
		marginBottom: 2,
		fontSize: '85%',
		letterSpacing: '1px',
	},
	greenCheckedIcon: {
		backgroundImage: `url('${GreenChecked}')`,
		display: 'inline-block',
		width: 60,
		height: 60,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 20,
	},
	greenCheckedIconSmall: {
		backgroundImage: `url('${GreenChecked}')`,
		display: 'inline-block',
		width: 16,
		height: 16,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	warningIcon: {
		backgroundImage: `url('${YellowWarning}')`,
		display: 'inline-block',
		width: 60,
		height: 60,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 10,
	},
	warningIconSmall: {
		backgroundImage: `url('${YellowWarning}')`,
		display: 'inline-block',
		width: 22,
		height: 22,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	errorIcon: {
		backgroundImage: `url('${ErrorIcon}')`,
		display: 'inline-block',
		width: 60,
		height: 60,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 10,
	},
	errorIconSmall: {
		backgroundImage: `url('${ErrorIcon}')`,
		display: 'inline-block',
		width: 18,
		height: 18,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	deliverySection: {
		borderLeft: `2px solid #eee`,
		paddingLeft: 5,
		marginLeft: 5,
	},
	deliveryBottom: {
		marginTop: 5,
		paddingTop: 5,
		borderTop: `1px solid #eee`,
	},
	deliverySelected: {
		borderLeft: `2px solid ${pBlue}`,
	},
	submitButton: {
		fontSize: 18,
		borderRadius: '100px',
		padding: '20px 30px',
		textTransform: 'uppercase',
	},
	submitInvalidButton: {
		fontSize: 14,
		borderRadius: '100px',
		//padding: '20px 30px',
		textTransform: 'uppercase',
		marginRight: 10,
	},
	rerunButton: {
		borderRadius: '100px',
		padding: '5px 10px',
		height: 30,
	},
});

class TriageApIngestionResult extends FormComponent {
	constructor(props) {
		super(props);

		const apIngestionResultId = _.get(this.props, ['match', 'params', 'apIngestionResultId']);

		this.state = {
			apIngestionResultId: parseInt(apIngestionResultId, 10),
			apIngestionDocumentId: [],
			apIngestionDocument: [],
			isSavingOpen: false,
			isInvalidOpen: false,
			savingStatus: undefined,

			formFieldError: {},
			invoiceDocuments: [],

			//- Default form values
			isConfirmationOpen: false,
			vendorBillOrders: [
				{
					bolNumberToInvoiceIdHash: {},
					carrierPoNumberToInvoiceIdHash: {},
					vendorBillOrderLineItems: [{}],
					isRackToRackTransfer: false,
					isInventoryTransfer: false,
				},
			],
			searchResultsForOrder: [],
			isSearchingForOrder: [],
			isConfirmInvalidateOpen: false,
		};
	}

	componentDidMount() {
		const {
			apIngestionResult,
			apIngestionResultGet,
			quickbooksTerms,
			searchQuickbooksTerms,
			suppliers,
			searchSuppliers,
			carriers,
			searchCarriers,
		} = this.props;
		const { apIngestionResultId } = this.state;

		if (_.isEmpty(quickbooksTerms)) {
			searchQuickbooksTerms();
		}

		if (_.isEmpty(suppliers)) {
			searchSuppliers();
		}

		if (_.isEmpty(carriers)) {
			searchCarriers();
		}

		if (!apIngestionResult) {
			apIngestionResultGet({
				params: {
					apIngestionResultIds: [apIngestionResultId],
				},
			});
		} else {
			const newState = this.fillForm();

			this.setState(newState, () => {
				if (newState.vendorBillOrders) {
					const order = newState.vendorBillOrders[0];
					if (order.carrierPoNumber || order.bolNumber) {
						this.searchForInvoiceMatch({ orderIndex: 0, noSet: true });
					}
				}
			});
		}
	}

	// eslint-disable-next-line no-unused-vars
	componentDidUpdate(prevProps, prevState, snapshot) {
		if (
			_.isUndefined(prevProps.apIngestionResult) &&
			!_.isUndefined(this.props.apIngestionResult)
		) {
			const newState = this.fillForm();
			this.setState(newState, () => {
				if (newState.vendorBillOrders) {
					const order = newState.vendorBillOrders[0];
					if (order.carrierPoNumber || order.bolNumber) {
						this.searchForInvoiceMatch({ orderIndex: 0, noSet: true });
					}
				}
			});
		}

		// TODO FUEL
		if (_.isEmpty(prevProps.carriers) && !_.isEmpty(this.props.carriers) && this.state.carrierId) {
			const newState = {};
			this.getTermsFromCarrier({
				newState,
				carrierId: parseInt(this.state.carrierId, 10),
			});
			this.setState(newState);
		}
	}

	fillForm = () => {
		const { apIngestionResult, apIngestionDocumentMap, resourceMap, showErrors } = this.props;
		if (!apIngestionResult) {
			return {};
		}

		// Extract the data from each apIngestionDocument for the form

		const { apIngestionDocumentId, matchResult } = apIngestionResult;
		const apDoc = apIngestionDocumentMap[apIngestionDocumentId];
		if (!apDoc) {
			console.error(`Missing doc: ${apIngestionDocumentId}`);
			return {};
		}
		const { documentResourceId, extractedData } = apDoc;

		const newState = {};
		[
			'typeOfBill',
			'supplierId',
			'carrierId',
			// These are set when the carrier is set
			//'quickbooksVendorId',
			//'quickbooksTermId',
			'billNumber',
			'billDate',
		].forEach((key) => {
			if (_.isNil(extractedData[key])) {
				return;
			}
			newState[key] = extractedData[key];
		});
		const {
			typeOfBill,
			billTotal,
			carrierPoNumber,
			demurrageAmount,
			bolNumber,
			netGallons,
			unitPrice,
		} = extractedData;

		let vendorBillOrder;
		if (typeOfBill === 'fuel') {
			const { bolNumberToInvoiceIds, fuelQuickbooksAccountId, quickbooksItemId, vendorBillOrderLineItems } = matchResult;
			const bolNumberToInvoiceIdHash = {};
			if (!_.isEmpty(bolNumberToInvoiceIds)) {
				bolNumberToInvoiceIds.forEach((id) => {
					bolNumberToInvoiceIdHash[id + ''] = true;
				});
			}

			// Use pre-built line items (fuel + taxes) from the backend if available,
			// otherwise fall back to the fuel-only item.
			const lineItems = vendorBillOrderLineItems || [
				{
					quantity: netGallons,
					unitPrice,
					quickbooksItemId,
					quickbooksAccountId: fuelQuickbooksAccountId,
					amount: billTotal,
				},
			];

			vendorBillOrder = {
				bolNumber,
				bolNumberToInvoiceIdHash,
				carrierPoNumberToInvoiceIdHash: {},
				vendorBillOrderLineItems: lineItems,
				isInventoryTransfer: false,
			};
		} else {
			const { carrierPoNumberToInvoiceIds, freightQuickbooksAccountId, linkedBulkDeliveryId } =
				matchResult;
			const carrierPoNumberToInvoiceIdHash = {};
			if (!_.isEmpty(carrierPoNumberToInvoiceIds)) {
				carrierPoNumberToInvoiceIds.forEach((id) => {
					carrierPoNumberToInvoiceIdHash[id + ''] = true;
				});
			}
			vendorBillOrder = {
				carrierPoNumber,
				bolNumberToInvoiceIdHash: {},
				carrierPoNumberToInvoiceIdHash,
				vendorBillOrderLineItems: [
					{
						amount: billTotal,
						quickbooksAccountId: freightQuickbooksAccountId,
						demurrageAmount,
					},
				],
				isRackToRackTransfer: false,
				linkedBulkDeliveryId,
				isInventoryTransfer: false,
			};
		}

		newState.vendorBillOrders = [vendorBillOrder];

		// get the resource
		if (documentResourceId) {
			const resource = resourceMap[documentResourceId];
			if (!resource) {
				showErrors([`Cant find document. Resource id : ${documentResourceId}`]);
				return {};
			}
			newState.vendorDocumentResource = resource;
		}

		if (extractedData.carrierId) {
			this.getTermsFromCarrier({
				newState,
				carrierId: parseInt(extractedData.carrierId, 10),
			});
		}

		if (extractedData.supplierId) {
			this.getTermsFromSupplier({
				newState,
				supplierId: parseInt(extractedData.supplierId, 10),
			});
		}
		return newState;
	};

	getTermsFromSupplier = getTermsFromSupplier.bind(this);
	getTermsFromCarrier = getTermsFromCarrier.bind(this);

	closeInvalidDialog = () => {
		this.setState({ isInvalidOpen: false });
	};

	closeSavingDialog = () => {
		this.setState({ isSavingOpen: false });
	};
	handleContinue = () => {
		const { vendorBillId } = this.state;
		this.props.history.push(`/billing/vendorBill/update/${vendorBillId}`);
	};

	handleCreateVendorBill = () => {
		const { apIngestionResultId } = this.state;
		const { showErrors, apIngestionResultGet } = this.props;
		this.setState({
			isSavingOpen: true,
			savingStatus: 'saving',
		});

		let vendorBillId;
		async.waterfall(
			[
				(callback) => {
					this.save({
						apIngestionResultId,
						callback,
					});
				},
				(r, callback) => {
					vendorBillId = _.first(r?.vendorBillIds);
					apIngestionResultGet({
						params: {
							apIngestionResultIds: [apIngestionResultId],
						},
						callback,
					});
				},
			],
			(err) => {
				if (err) {
					this.setState({
						isSavingOpen: false,
					});
					showErrors([`Error creating new vendor bill.`, err]);
					return;
				}

				if (!vendorBillId) {
					this.setState({
						isSavingOpen: false,
					});
					showErrors([`Strange the vendor bill creation did hot get a vendor bill back.`, err]);
				}

				this.setState({
					vendorBillId,
					savingStatus: 'done',
				});
			}
		);
	};

	handleRerun = () => {
		const { apIngestionResultId } = this.state;
		const { showErrors, apIngestionResultRerun } = this.props;
		this.setState({
			isSavingOpen: true,
			savingStatus: 'saving',
		});

		async.waterfall(
			[
				(callback) => {
					apIngestionResultRerun({
						params: {
							apIngestionResultId,
						},
						callback,
					});
				},
			],
			(err) => {
				setTimeout(() => {
					this.setState({
						isSavingOpen: false,
					});
					const newState = this.fillForm();
					this.setState({ ...newState, isSavingOpen: false }, () => {
						if (newState.vendorBillOrders) {
							const order = newState.vendorBillOrders[0];
							if (order.carrierPoNumber || order.bolNumber) {
								this.searchForInvoiceMatch({ orderIndex: 0, noSet: true });
							}
						}
					});

					if (err) {
						showErrors([`Error rerunning new vendor bill.`, err]);
						return;
					}
				}, 1000);
			}
		);
	};

	save = save.bind(this);
	searchForInvoiceMatch = searchForInvoiceMatch.bind(this);

	//
	//
	//render
	//
	//

	render() {
		const { apIngestionResult, apIngestionDocumentMap, userMap, classes } = this.props;
		const { vendorDocumentResource, apIngestionResultId } = this.state;

		if (!apIngestionResult || _.isEmpty(vendorDocumentResource)) {
			return <div>Loading...</div>;
		}

		// Load it up
		const { apIngestionDocumentId, invalidReason, markedInvalidByUserId } = apIngestionResult;
		const apDoc = apIngestionDocumentMap[apIngestionDocumentId];
		if (!apDoc) {
			return console.error(`Missing doc: ${apIngestionDocumentId}`);
		}
		const { extractedData } = apDoc;
		const { typeOfBill } = extractedData;

		const user = userMap[markedInvalidByUserId] || { firstName: 'Missing' };
		const resource = vendorDocumentResource;

		return (
			<Grid container spacing={0}>
				{!!invalidReason && (
					<Grid item xs={12} style={{ textAlign: 'left' }}>
						<Note>
							<div>
								<strong style={{ fontSize: 18 }}>Marked Invalid</strong>
							</div>
							<div>Invalid Reason: {invalidReason}</div>
							<div>
								Invalided by: {user.firstName} {user.lastName}
							</div>
						</Note>
					</Grid>
				)}

				<Grid item xs={12}>
					{this.renderMatch()}
				</Grid>

				<Grid item xs={12}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={6}>
							<FMPRegionHeader isTop={true} label={'Extracted Info'} />
							<Paper className={classes.paper}>
								<FMPSelect
									{...this.setForm('typeOfBill')}
									label="Type of bill"
									options={[
										{ value: 'fuel', display: 'Fuel Bill' },
										{ value: 'freight', display: 'Freight Bill' },
									]}
								/>

								{typeOfBill && this.renderBillFields()}
								<div style={{ marginTop: 20 }}>{this.renderButtons()}</div>
							</Paper>
						</Grid>
						<Grid item xs={12} sm={6}>
							<FMPRegionHeader isTop={true} label={`Bill Document`} />
							<Paper
								className={classes.paper}
								style={{ position: 'sticky', top: 10, height: '90vh' }}
							>
								<Fragment>
									<object
										data={resource.url}
										style={{ height: '100%', width: '100%', maxWidth: '100%' }}
										type={resource.contentType}
									//width="175"
									//height="175"
									>
										<a href={resource.url}>BillDocument.pdf</a>
									</object>
								</Fragment>
							</Paper>
						</Grid>
					</Grid>

					<GenericSavingDialog
						open={this.state.isSavingOpen}
						onClose={this.closeSavingDialog}
						onContinue={this.handleContinue}
						processingText={'Processing Triage Result...'}
						successText={'Click continue button to go to the new vendor bill to finalize.'}
						status={this.state.savingStatus}
					/>
					<ConfirmInvalidateApArTriage
						open={this.state.isInvalidOpen}
						onClose={this.closeInvalidDialog}
						apIngestionResultId={apIngestionResultId}
						invalidateTriageResult={this.props.apIngestionResultUpdate}
						history={this.props.history}
						showErrors={this.props.showErrors}
					/>
				</Grid>
			</Grid>
		);
	}

	renderBillFields = renderBillFields.bind(this);
	renderBillTotal = renderBillTotal.bind(this);
	renderOrders = renderOrders.bind(this);
	renderMarkTransfer = renderMarkTransfer.bind(this);
	renderSearchResultOrCurrentLinkage = renderSearchResultOrCurrentLinkage.bind(this);
	renderSearchResult = renderSearchResult.bind(this);
	renderMatchStatus = renderMatchStatus.bind(this);
	renderInvoiceMatches = renderInvoiceMatches.bind(this);
	renderInvoiceDetails = renderInvoiceDetails.bind(this);
	renderFuelLineItems = renderFuelLineItems.bind(this);
	renderFreightLineItems = renderFreightLineItems.bind(this);

	onDocumentClick = (invoiceDocuments) => {
		this.setState({
			isInvoiceDocumentPopupOpen: true,
			invoiceDocumentsPoppedUp: invoiceDocuments,
		});
	};

	handleCloseInvoiceDocumentPopup = () => {
		this.setState({
			isInvoiceDocumentPopupOpen: false,
			invoiceDocumentsPoppedUp: [],
		});
	};

	closeMultiPageBillDialog = () => {
		this.setState({ isMultiPageBillDialogOpen: false });
	};
	openMultiPageBillDialog = () => {
		this.setState({ isMultiPageBillDialogOpen: true });
	};

	renderMatch = () => {
		const {
			apIngestionResult,
			apIngestionDocumentMap,
			// carrierMap,
			carrierPoNumberToInvoiceMap,
			// stationInvoiceMap,
			// stationDeliveryMap,
			// stationMap,
			classes,
		} = this.props;

		const { apIngestionDocumentId, matchResult, matchResultStatus, invalidReason } =
			apIngestionResult;
		const apDoc = apIngestionDocumentMap[apIngestionDocumentId];
		const { typeOfBill } = (apDoc && apDoc.extractedData) || {};

		const isGood = matchResultStatus === 'matched';
		let isInvalidButtonDisabled = false;

		if (invalidReason) {
			isInvalidButtonDisabled = true;
		}

		const { carrierPoNumberToInvoiceIds, bolNumberToInvoiceIds, matchInfoForFields, isRackToRack } =
			matchResult;

		let invoiceInfo;

		if (typeOfBill === 'fuel') {
			invoiceInfo = (
				<div>BOL Number did not match any invoices. They may not be in the system yet.</div>
			);
			if (!_.isEmpty(bolNumberToInvoiceIds)) {
				invoiceInfo = bolNumberToInvoiceIds.map((bolNumberToInvoiceId) =>
					this.getInfoForBolMatch({ bolNumberToInvoiceId })
				);
			}
		} else {
			invoiceInfo = (
				<div>PO Number did not match any invoices. They may not be in the system yet.</div>
			);

			if (isRackToRack) {
				invoiceInfo = (
					<div>
						Customer name matched a rack to rack transfer customer. Marking as a rack to rack
						transfer, please double check this is correct.
					</div>
				);
			}

			if (!_.isEmpty(carrierPoNumberToInvoiceIds)) {
				invoiceInfo = carrierPoNumberToInvoiceIds.map((carrierPoNumberToInvoiceId) => {
					const carrierPoNumberToInvoice =
						carrierPoNumberToInvoiceMap[carrierPoNumberToInvoiceId];
					if (!carrierPoNumberToInvoice) {
						return <div>Missing carrierPoNumberToInvoice:{carrierPoNumberToInvoice}</div>;
					}

					const {
						stationInvoiceId,
						bulkInvoiceId,
						rackTransferId,
						carrierPoNumber,

						linkedToVendorBillId,
						linkedToVendorBillOrderId,
					} = carrierPoNumberToInvoice;

					console.log(carrierPoNumberToInvoice, 'carrierPoNumberToInvoice');

					if (stationInvoiceId) {
						return this.getInfoForPoMatchOnStation({
							stationInvoiceId,
							carrierPoNumberToInvoiceId,
							carrierPoNumber,
							linkedToVendorBillId,
							linkedToVendorBillOrderId,
						});
					} else if (bulkInvoiceId) {
						return this.getInfoForPoMatchOnBulk({
							bulkInvoiceId,
							carrierPoNumberToInvoiceId,
							carrierPoNumber,
							linkedToVendorBillId,
							linkedToVendorBillOrderId,
						});
					} else if (rackTransferId) {
						return this.getInfoForPoMatchOnRackTransfer({
							rackTransferId,
							carrierPoNumberToInvoiceId,
							carrierPoNumber,
							linkedToVendorBillId,
							linkedToVendorBillOrderId,
						});
					} else {
						return 'Error: Matched a bulk invoice for PO Number.';
					}
				});
			}
		} // end else (freight)

		let matchInfo;
		if (!matchResult) {
			matchInfo = <div>Missing matchResult</div>;
		} else if (_.isEmpty(matchInfoForFields)) {
			matchInfo = <div>Match is empty. Possible ingestion issue. Check document.</div>;
		} else {
			matchInfo = (
				<div>
					{/*{matchResultStatusMessage && <div>{matchResultStatusMessage}</div>}*/}
					{matchInfoForFields.map(({ message, isError }, i) => {
						return (
							<div key={`top_${i}`}>
								{isError && (
									<>
										<span className={classes.errorIconSmall} /> : {message}
									</>
								)}
								{!isError && (
									<>
										<span className={classes.greenCheckedIconSmall} /> {message}
									</>
								)}
							</div>
						);
					})}
				</div>
			);
		}

		let title = isGood ? 'All Data Matched. Yes!' : 'Has matching issues. Please review.';
		if (matchResultStatus === 'possibleRackToRack') {
			title = 'Has matching issues. Maybe a Rack to Rack Transfer. Please review.';
		}

		const iconClass = isGood ? classes.greenCheckedIcon : classes.warningIcon;

		return (
			<Paper className={classes.paper}>
				<div>
					<div style={{ display: 'flex', justifyContent: 'space-between' }}>
						<div className={classes.overallMatchTitle}>
							<span className={iconClass} />
							{title}
						</div>

						<Button
							variant="outlined"
							onClick={this.handleRerun}
							color="primary"
							className={classes.rerunButton}
							disabled={isInvalidButtonDisabled}
						>
							Reprocess
						</Button>
					</div>

					<div style={{ display: 'flex', width: '100%' }}>
						<div className={classes.overallMatchSectionContainer} style={{ width: '33%' }}>
							<div className={classes.overallMatchSectionLabel}>Matching Invoice(s)</div>
							<div>{invoiceInfo}</div>
						</div>

						<div className={classes.overallMatchSectionContainer}>
							<div className={classes.overallMatchSectionLabel}>Matching Data</div>
							<div>{matchInfo}</div>
						</div>
					</div>
				</div>
				<div>{this.renderButtons()}</div>
			</Paper>
		);
	};

	getInfoForPoMatchOnStation({
		stationInvoiceId,
		carrierPoNumberToInvoiceId,
		carrierPoNumber,
		linkedToVendorBillId,
		linkedToVendorBillOrderId,
	}) {
		const { stationInvoiceMap, stationMap, classes } = this.props;

		const stationInvoice = stationInvoiceMap[stationInvoiceId];
		if (!stationInvoice) {
			return <div>Can not find stationInvoice: {stationInvoiceId}</div>;
		}

		const { stationId, issueDate } = stationInvoice;
		const station = stationMap[stationId] || { number: '', name: 'Missing station' };
		const destinationDisplay = `${station.number} - ${station.name}`;

		return (
			<div key={carrierPoNumberToInvoiceId} style={{ paddingBottom: '20px' }}>
				<div>
					<div className={classes.greenCheckedIconSmall} /> PO Number:{' '}
					<strong>{carrierPoNumber}</strong> matched following invoices:
				</div>
				<div style={{ paddingLeft: '10px' }}>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
						}}
					>
						Station Invoice #<strong>{stationInvoiceId}</strong>
						<a
							href={`/accounting/stationInvoice/update/${stationInvoiceId}`}
							style={{ textDecoration: 'none', paddingTop: 5, paddingLeft: 5 }}
							target="_blank"
							rel="noreferrer noopener"
						>
							<OpenLink style={{ width: 20, height: 20 }} />
						</a>
					</div>
					<div>Station: {destinationDisplay}</div>
					<div>Issue Date : {moment(issueDate).format('dddd, M/D h:mm a')}</div>

					{linkedToVendorBillOrderId && (
						<div className={classes.alreadyLinked}>
							<div className={classes.alreadyLinkedIcon} />
							Already linked to Vendor Bill
							<a
								href={`/billing/vendorBill/update/${linkedToVendorBillId}`}
								style={{ textDecoration: 'none' }}
								target="_blank"
								rel="noreferrer noopener"
							>
								{' '}
								#{linkedToVendorBillId}
							</a>
						</div>
					)}
				</div>
			</div>
		);
	}

	getInfoForPoMatchOnBulk({
		bulkInvoiceId,
		carrierPoNumberToInvoiceId,
		carrierPoNumber,
		linkedToVendorBillId,
		linkedToVendorBillOrderId,
	}) {
		const { bulkInvoiceMap, classes, bulkCustomerMap } = this.props;

		const bulkInvoice = bulkInvoiceMap[bulkInvoiceId];
		if (!bulkInvoice) {
			return <div>Can not find bulkInvoiceId: {bulkInvoice}</div>;
		}

		const { bulkCustomerId, issueDate } = bulkInvoice;

		const bulkCustomer = bulkCustomerMap[bulkCustomerId] || {
			number: '',
			name: 'Missing bulk customer',
		};
		const bulkCustomerDisplay = `${bulkCustomer.name}`;
		return (
			<div key={carrierPoNumberToInvoiceId} style={{ paddingBottom: '20px' }}>
				<div>
					<div className={classes.greenCheckedIconSmall} /> PO Number:{' '}
					<strong>{carrierPoNumber}</strong> matched following bulk invoices:
				</div>
				<div style={{ paddingLeft: '10px' }}>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
						}}
					>
						Bulk Invoice #<strong>{bulkInvoiceId}</strong>
						<a
							href={`/accounting/bulkInvoice/update/${bulkInvoiceId}`}
							style={{ textDecoration: 'none', paddingTop: 5, paddingLeft: 5 }}
							target="_blank"
							rel="noreferrer noopener"
						>
							<OpenLink style={{ width: 20, height: 20 }} />
						</a>
					</div>

					<div>Bulk Customer {bulkCustomerDisplay}</div>
					<div>Issue Date : {moment(issueDate).format('dddd, M/D h:mm a')}</div>

					{linkedToVendorBillOrderId && (
						<div className={classes.alreadyLinked}>
							<div className={classes.alreadyLinkedIcon} />
							Already linked to Vendor Bill
							<a
								href={`/billing/vendorBill/update/${linkedToVendorBillId}`}
								style={{ textDecoration: 'none' }}
								target="_blank"
								rel="noreferrer noopener"
							>
								{' '}
								#{linkedToVendorBillId}
							</a>
						</div>
					)}
				</div>
			</div>
		);
	}

	getInfoForPoMatchOnRackTransfer({
		rackTransferId,
		carrierPoNumberToInvoiceId,
		carrierPoNumber,
		linkedToVendorBillId,
		linkedToVendorBillOrderId,
	}) {
		const { rackTransferMap, classes, bulkCustomerMap, bulkDeliveryMap } = this.props;

		const rackTransfer = rackTransferMap[rackTransferId];
		if (!rackTransfer) {
			return <div>Can not find rackTransfer: {rackTransferId}</div>;
		}

		const { linkedBulkDeliveryId, bulkCustomerId } = rackTransfer;

		const bulkCustomer = bulkCustomerMap[bulkCustomerId] || {
			number: '',
			name: 'Missing bulk customer',
		};
		const bulkCustomerDisplay = `${bulkCustomer.name}`;

		//- Delivery
		const bulkDelivery = bulkDeliveryMap[linkedBulkDeliveryId];
		let deliveryInfo = <span>Delivery {linkedBulkDeliveryId} not found</span>;
		if (bulkDelivery) {
			const { deliveryDate, bulkDeliveryId } = bulkDelivery;
			const dateDisplay = moment(deliveryDate).format('ddd, M/D');
			deliveryInfo = (
				<Fragment>
					<div>{bulkCustomerDisplay}</div>
					<div>Delivery #{bulkDeliveryId}</div>
					<div>{dateDisplay}</div>
				</Fragment>
			);
		}

		return (
			<div key={carrierPoNumberToInvoiceId} style={{ paddingBottom: '20px' }}>
				<div>
					<div className={classes.greenCheckedIconSmall} /> PO Number:{' '}
					<strong>{carrierPoNumber}</strong> matched following rack transfers:
				</div>
				<div style={{ paddingLeft: '10px' }}>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
						}}
					>
						Rack Transfer #<strong>{rackTransferId}</strong>
						<a
							href={`/accounting/rackTransfer/update/${rackTransferId}`}
							style={{ textDecoration: 'none', paddingTop: 5, paddingLeft: 5 }}
							target="_blank"
							rel="noreferrer noopener"
						>
							<OpenLink style={{ width: 20, height: 20 }} />
						</a>
					</div>
					{deliveryInfo}

					{linkedToVendorBillOrderId && (
						<div className={classes.alreadyLinked}>
							<div className={classes.alreadyLinkedIcon} />
							Already linked to Vendor Bill
							<a
								href={`/billing/vendorBill/update/${linkedToVendorBillId}`}
								style={{ textDecoration: 'none' }}
								target="_blank"
								rel="noreferrer noopener"
							>
								{' '}
								#{linkedToVendorBillId}
							</a>
						</div>
					)}
				</div>
			</div>
		);
	}

	getInfoForBolMatch({ bolNumberToInvoiceId }) {
		const { bolNumberToInvoiceMap, bulkInvoiceMap, bulkCustomerMap, classes } = this.props;

		const bolNumberToInvoice = bolNumberToInvoiceMap[bolNumberToInvoiceId];
		if (!bolNumberToInvoice) {
			return (
				<div key={bolNumberToInvoiceId}>
					Missing bolNumberToInvoice: {bolNumberToInvoiceId}
				</div>
			);
		}

		const { bolNumber, bulkInvoiceId, linkedToVendorBillOrderId, linkedToVendorBillId } =
			bolNumberToInvoice;

		const bulkInvoice = bulkInvoiceMap[bulkInvoiceId] || {};
		const { issueDate, bulkCustomerId } = bulkInvoice;
		const bulkCustomer = bulkCustomerMap[bulkCustomerId] || { name: 'Unknown' };

		return (
			<div key={bolNumberToInvoiceId}>
				<div>
					<span className={classes.greenCheckedIconSmall} /> BOL #{' '}
					<strong>{bolNumber}</strong> matched:
				</div>
				<div style={{ paddingLeft: 10 }}>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						Bulk Invoice #<strong>{bulkInvoiceId}</strong>
						<a
							href={`/accounting/bulkInvoice/update/${bulkInvoiceId}`}
							style={{ textDecoration: 'none', paddingTop: 5, paddingLeft: 5 }}
							target="_blank"
							rel="noreferrer noopener"
						>
							<OpenLink style={{ width: 20, height: 20 }} />
						</a>
					</div>
					<div>Bulk Customer: {bulkCustomer.name}</div>
					{issueDate && (
						<div>Issue Date: {moment(issueDate).format('dddd, M/D h:mm a')}</div>
					)}
					{linkedToVendorBillOrderId && (
						<div className={classes.alreadyLinked}>
							<div className={classes.alreadyLinkedIcon} />
							Already linked to Vendor Bill
							<a
								href={`/billing/vendorBill/update/${linkedToVendorBillId}`}
								style={{ textDecoration: 'none' }}
								target="_blank"
								rel="noreferrer noopener"
							>
								{' '}
								#{linkedToVendorBillId}
							</a>
						</div>
					)}
				</div>
			</div>
		);
	}

	renderButtons() {
		const { apIngestionResult, classes } = this.props;

		const { matchResultStatus, invalidReason } = apIngestionResult;

		const isGood = matchResultStatus === 'matched';
		let isGoodOrRackToRack = isGood;
		let isInvalidButtonDisabled = false;

		const { vendorBillOrders } = this.state;

		if (!_.isEmpty(vendorBillOrders)) {
			const isRackToRackTransfer = vendorBillOrders[0].isRackToRackTransfer;
			if (isRackToRackTransfer) {
				isGoodOrRackToRack = true;
			}
		}

		// Create is only hard-disabled when the result is explicitly marked invalid.
		// Missing/mismatched fields no longer block creating an unfinished bill.
		let isButtonDisabled = false;
		if (invalidReason) {
			isButtonDisabled = true;
			isInvalidButtonDisabled = true;
		}

		const isMissingFields = !isGoodOrRackToRack && !invalidReason;

		return (
			<div>
				<div style={{ textAlign: 'right' }}>
					<Button
						variant="outlined"
						className={classes.submitInvalidButton}
						onClick={() => {
							this.setState({ isInvalidOpen: true });
						}}
						disabled={isInvalidButtonDisabled}
					>
						Mark Invalid
					</Button>
					<Button
						variant={isMissingFields ? 'outlined' : 'contained'}
						color="primary"
						className={classes.submitButton}
						onClick={this.handleCreateVendorBill}
						disabled={isButtonDisabled}
					>
						Create New Vendor Bill
					</Button>
				</div>
				{isMissingFields && (
					<div
						style={{
							textAlign: 'right',
							marginTop: 10,
							padding: 10,
							border: '1px solid #f0c36d',
							color: '#8a6d3b',
						}}
					>
						You can still create this vendor bill, but some key fields are missing. It will be
						saved in an unfinished state.
					</div>
				)}
				{invalidReason && (
					<div style={{ textAlign: 'right', marginTop: 10, padding: 10, border: '1px solid #eee' }}>
						<strong>Invalid Reason:</strong> {invalidReason}
					</div>
				)}
			</div>
		);
	}
}

TriageApIngestionResult.propTypes = {
	apIngestionResultUpdate: PropTypes.func.isRequired,
	apIngestionResultGet: PropTypes.func.isRequired,
	apIngestionResultRerun: PropTypes.func.isRequired,
	apIngestionDocumentMap: PropTypes.object,
	addInvoiceDocument: PropTypes.func.isRequired,

	addVendorBill: PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,
	theme: PropTypes.object.isRequired,
	showErrors: PropTypes.func.isRequired,
	history: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	StationInvoiceContainer,
	InvoiceDocumentContainer,
	ApIngestionResultContainer,
	QuickbooksContainer,
	SuppliersContainer,
	CarriersContainer,
	VendorBillContainer,
])(TriageApIngestionResult);
